import { RouteConfig } from 'vue-router';

export default {
  path: 'privacy-policy',
  name: 'page-privacy-policy',
  component: () => import('./pagePrivacyPolicy.vue'),
  meta: {
    title: 'Política de privacidade',
  },
} as RouteConfig;
